import React, { useState, useEffect, useRef } from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonSelect,
  IonSelectOption,
  IonItem,
  IonLabel,
  IonInput,
  IonText,
} from '@ionic/react';
import './SignUpPage.css';
import { useSignUp } from './UserSignUp'; // Adjust path as necessary
import AccountOwnerSignUp from './AccountOwnerSignUp'; // Adjust path as necessary
import CustomManufacturerPopUp from './CustomManufacturerPopUp';
import UserTypePopUp from './UserTypePopUp';
import IconButton from '../../components/IconButton/IconButton';
import { LoginModalContentWrapper, LoginModalHeaderWrapper, LoginModalWrapper } from '../../components/LoginModal/LoginModal';
import { Scan, X } from 'lucide-react';
import { FormRow } from '../Common/LandingPage/SectionContent/AboutContent';
import Input from '../../components/Input';
import Select from '../../components/Select/Select';
import { useTheme } from '@emotion/react';
import Button from '../../components/Button/Button';
import styled from '@emotion/styled';
import { CustomThemeType } from '../../context/Providers';

const NoticeWrapper = styled.div<{theme?: CustomThemeType}>`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  & svg {
    color: ${p => `color-mix(in srgb, ${p.theme.foreground}, ${p.theme.background} 90%)`};
  }
  & p {
    color: ${p => p.theme.foreground};
    text-align: center;
  }
  & a {
    text-decoration: underline;
  }
  & a:hover {
    cursor: pointer;
  }
  @media (max-width: 700px) {
    width: 70%;
  }
  @media (max-width: 550px) {
    width: 90%;
  }
`;

interface SignUpPageProps {
  isOpen: boolean;
  onClose: () => void;
  onGetInTouchClick?: () => any;
}

const SignUpPage: React.FC<SignUpPageProps> = ({ isOpen, onClose, onGetInTouchClick }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [userType, setUserType] = useState('');
  const [dealerId, setDealerId] = useState('');
  const [showCustomManufacturer, setShowCustomManufacturer] = useState(false);
  const [customManufacturer, setCustomManufacturer] = useState('');
  const [showUserTypePopUp, setShowUserTypePopUp] = useState(false);
  const [showAccountOwnerSignUp, setShowAccountOwnerSignUp] = useState(false);
  const modalRef = useRef<HTMLIonModalElement>(null);

  const { signUpUser, isLoading } = useSignUp(() => {
    if (userType === 'User') {
      onClose();
    }
  });

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.offsetHeight; // Trigger reflow
    }
  }, [isOpen]);

  const handleSignUp = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    if (userType === 'Account Owner' && !dealerId) {
      alert("Dealer ID is required for account owners.");
      return;
    }

    if (manufacturer === 'Other') {
      setShowCustomManufacturer(true);
      return;
    }

    if (!userType) {
      alert("Please select your user type.");
      return;
    }

    if (userType === 'User') {
      signUpUser({ email, password, manufacturer });
    } else if (userType === 'Account Owner') {
      setShowAccountOwnerSignUp(true);
    }
  };

  const theme: any = useTheme();

  return (
    <>
      <IonModal isOpen={isOpen} onDidDismiss={onClose} ref={modalRef}>
        <LoginModalWrapper>
          <LoginModalHeaderWrapper>
            <h4>Access by Invitation Only</h4>
            <IconButton onClick={() => onClose()}>
              <X style={{ marginRight: '1rem' }} />
            </IconButton>
          </LoginModalHeaderWrapper>
          <LoginModalContentWrapper>
            <NoticeWrapper>
              <Scan size="10rem" />
              <p>
                Cabinet Scanner is a production platform used by participating cabinet manufacturers to manage deliveries across their dealers, warehouses, and drivers.
              </p>
              <p>
                Access is not offered as a public beta or free trial. Each account is activated only after we confirm a manufacturer partnership and subscription.
              </p>
              <p>
                Access is provisioned after an onboarding meeting with our team. Once a manufacturer account is created, its administrators can invite dealers and other users through the dashboard.
              </p>
              <p>
                Need to get connected?{" "}
                <a onClick={() => onGetInTouchClick?.()}>Request access</a>.
              </p>
            </NoticeWrapper>
            { /* <form onSubmit={handleSignUp} style={{ marginTop: '1rem', width: '80%' }}>
              <LoginModalContentWrapper>
                <FormRow labelWidth='100%'>
                  <label>
                    Email:
                    <Input
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </label>
                </FormRow>
                <FormRow labelWidth='100%'>
                  <label>
                    Password:
                    <Input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </label>
                </FormRow>
                <FormRow labelWidth='100%'>
                  <label>
                    Confirm Password:
                    <Input
                      type="password"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </label>
                </FormRow>
                <FormRow labelWidth='100%'>
                  <label>
                    Confirm Password:
                    <Input
                      type="password"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </label>
                </FormRow>
                <FormRow labelWidth='100%'>
                  <label>
                    Cabinet Manufacturer:
                    <IonSelect value={manufacturer} onIonChange={e => setManufacturer(e.detail.value)} placeholder="Select One"
                      style={{
                        color: theme.foreground,
                        padding: '.5rem',
                        backgroundColor: `color-mix(in hsl, ${theme.background}, ${theme.foreground} 10%)`,
                        border: 'none',
                        borderRadius: '.25rem',
                        outline: 'none'
                      }}
                    >
                      <IonSelectOption value="Wood-Mode">Wood-Mode</IonSelectOption>
                      <IonSelectOption value="Other">Other</IonSelectOption>
                    </IonSelect>
                  </label>
                </FormRow>
                <FormRow labelWidth='100%'>
                  <label>
                    User Type:
                    <IonSelect value={userType} onIonChange={e => setUserType(e.detail.value)} placeholder="Select One"
                      style={{
                        color: theme.foreground,
                        padding: '.5rem',
                        backgroundColor: `color-mix(in hsl, ${theme.background}, ${theme.foreground} 10%)`,
                        border: 'none',
                        borderRadius: '.25rem',
                        outline: 'none'
                      }}
                    >
                      <IonSelectOption value="Account Owner">Account Owner</IonSelectOption>
                      <IonSelectOption value="User">User</IonSelectOption>
                    </IonSelect>
                  </label>
                </FormRow>
                {userType === 'Account Owner' && (
                  <FormRow labelWidth='100%'>
                    <label>
                      Dealer ID
                      <Input
                        type="text"
                        placeholder="Dealer ID"
                        value={dealerId}
                        onChange={(e) => setDealerId(e.target.value)}
                      />
                    </label>
                  </FormRow>
                )}
                <FormRow labelWidth='100%'>
                  <Button size="md" type="submit" disabled={isLoading} style={{ width: '100%', margin: '1rem .5rem 0 .5rem', padding: '1rem', backgroundColor: theme.brand }}>{isLoading ? 'Loading...' : 'Request Access'}</Button>
                </FormRow>
              </LoginModalContentWrapper>
            </form> */}
          </LoginModalContentWrapper>
        </LoginModalWrapper>
      </IonModal>
      {showCustomManufacturer && (
        <CustomManufacturerPopUp
          isOpen={showCustomManufacturer}
          onClose={() => setShowCustomManufacturer(false)}
          userData={{ email, password, dealerId, customManufacturer, userType }}
        />
      )}
      {showUserTypePopUp && (
        <UserTypePopUp
          isOpen={showUserTypePopUp}
          onClose={() => setShowUserTypePopUp(false)}
          userData={{ email, password, dealerId, manufacturer, customManufacturer, userType }}
        />
      )}
      {showAccountOwnerSignUp && (
        <AccountOwnerSignUp
          isOpen={showAccountOwnerSignUp}
          onClose={() => setShowAccountOwnerSignUp(false)}
          email={email}
          password={password}
          dealerId={dealerId}
          manufacturer={manufacturer === 'Other' ? customManufacturer : manufacturer}
        />
      )}
    </>
  );
};

export default SignUpPage;
